module.exports = __webpack_public_path__ + "img/ocrc_logo_fr.3825a240.svg";